import React from 'react'
import { useTranslation } from 'react-i18next'
import Message from '../../../../../../../components/messenger/Message'
import { COLORS } from '@btime/constants'
import Separator from '../../../../../../../components/helpers/Separator'

const LegacyWarning = ({ questionType }) => {
  const { t } = useTranslation('editChecklist')
  const legacyMessage = t('legacyQuestionTypeMessage', { ns: 'editChecklist' })

  if (questionType !== 'cpf_cnpj') return false

  return (
    <>
      <Message
        title={`🚨 **${t('legacyQuestionTypeTitle')}** \n ${legacyMessage}`}
        useMarkdown={true}
        color={COLORS.dark3}
        bgColor={COLORS.lightYellow}
      />
      <Separator weight={4} />
    </>
  )
}

export default LegacyWarning
